---
layout: docs
title: "Multi-Cloud Status"
---


Corral is Azure-first by design. AWS and GCP support is on the roadmap.

---

## Azure — Production

Azure is Corral's primary platform. Azure Managed Applications provide the most complete publisher-managed deployment model of any cloud — managed resource groups, configurable publisher access, built-in marketplace billing, and federated identity for maintenance.

All current deployments are Azure. The marketplace listing, billing, deployment automation, and maintenance workflows are built for Azure.

---

## AWS — Planned (2026)

AWS Marketplace has no direct equivalent to Azure Managed Applications. Two architectural approaches have been evaluated:

**CloudFormation + Cross-Account IAM**: The customer deploys a CloudFormation template that creates resources in their account and grants Corral cross-account access via IAM roles. Functionally equivalent to the Azure model but less elegant — no managed resource group concept, no built-in publisher access tiers.

**Hybrid Architecture**: Corral runs compute in Corral's own AWS account. The customer deploys only stateful resources (databases, storage) in their account, connected via AWS PrivateLink. This provides data residency while giving Corral full operational control over the application layer.

The hybrid approach may offer advantages for operational control and is being evaluated.

---

## GCP — Planned (after AWS)

GCP Marketplace has the most significant gaps relative to Azure. No managed deployment concept and limited customer-deployed product types. The hybrid architecture (Corral compute + customer data via Private Service Connect) is the likely path.

Timeline depends on customer demand.

---

## What Multi-Cloud Means for You

If you're evaluating Corral and your primary cloud is AWS or GCP:

- **Azure is the recommended starting point** if you have any Azure presence — the deployment model is most mature
- **AWS support is the next priority** — if you're AWS-only, reach out to discuss timeline and design partnership opportunities
- **GCP support follows AWS** — same offer applies

The platform itself is designed to be cloud-portable at the application layer. The deployment and infrastructure layer is what's cloud-specific.
